<template>
    <div>

        <template v-if="clientDetail">
            <!--<Row>{{clientDetail.name}} (<span :style="{color: getColor(clientDetail.status)}">{{clientDetail.status}}</span>)</Row>-->
            <Row :gutter="10" style="font-size: 15px">
                <Col :md="8">
                    <Row :gutter="10">
                        <Col :md="8" style="color: #444444">Client Name</Col><Col span="1">:</Col>
                        <Col :md="12">{{clientDetail.name}}</Col>
                        <Col :md="8" style="color: #444444">Mobile No.</Col><Col span="1">:</Col>
                        <Col :md="12">{{clientDetail.mobile}}</Col>
                        <Col :md="8" style="color: #444444">Email</Col><Col span="1">:</Col>
                        <Col :md="12">{{clientDetail.email}}</Col>
                        <Col :md="8" style="color: #444444">Address</Col><Col span="1">:</Col>
                        <Col :md="12">{{getAddressString(clientDetail.address[0])}}</Col>
                    </Row>
                </Col>
                <Col :md="8">
                    <Row :gutter="10">
                        <Col :md="8" style="color: #444444">GST</Col><Col span="1">:</Col>
                        <Col :md="12">{{clientDetail.gstin?clientDetail.gstin:'-'}}</Col>
                        <Col :md="8" style="color: #444444">PAN</Col><Col span="1">:</Col>
                        <Col :md="12">-</Col>
                        <Col :md="8" style="color: #444444">City</Col><Col span="1">:</Col>
                        <Col :md="12">{{clientDetail.address[0].city}}</Col>
                        <Col :md="8" style="color: #444444">Status</Col><Col span="1">:</Col>
                        <Col :md="12">
                          <i-switch v-model="clientDetail.isApproved" @on-change="onChangeStatus(clientDetail)"
                                    :style="clientDetail.isApproved?'background: green':'background: red'"/>
                        </Col>
                    </Row>
                </Col>
                <Col :md="8">
                    <Row :gutter="10">
                        <Col :md="8" style="color: #444444">Total Orders</Col><Col span="1">:</Col>
                        <Col :md="12">{{orders.length}}</Col>
                        <Col :md="8" style="color: #444444">Total Bill Amt</Col><Col span="1">:</Col>
                        <Col :md="12">-</Col>
                        <Col :md="8" style="color: #444444">Total Paid Amt</Col><Col span="1">:</Col>
                        <Col :md="12">-</Col>
                        <Col :md="8" style="color: #444444">Due Amt</Col><Col span="1">:</Col>
                        <Col :md="12">-</Col>
                        <Col :md="8" style="color: #444444">Send SMS</Col><Col span="1">:</Col>
                        <Col :md="12">
                          <i-switch v-model="clientDetail.preference.sendSms" @on-change="onChangeSendSms(clientDetail)"
                                    :style="clientDetail.preference.sendSms?'background: green':'background: red'"/>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </template>


        <Tabs v-model="screen" type="card" style="margin-top: 50px">
            <TabPane label="Details" name="details"></TabPane>
            <TabPane label="Order Details" name="order_details"></TabPane>
        </Tabs>

        <div v-show="screen === 'details'">
        <Row :gutter="10">
            <Col :md="12">

              <Button icon="md-add" @click="openDetailForm('addCompanyUserDrawer')">Add User</Button>
                <hot-table :settings="companyUsers_hotSettings" style="margin: 20px 0 0 0">
                    <hot-column v-for="(colset, index) in companyUsers_columns" :settings="colset" :key="index">
                    </hot-column>
                </hot-table>
            </Col>
          <Col :md="12">
                <Button icon="md-add" @click="openDetailForm('addContactDrawer')">Add Contact</Button>
                <hot-table :settings="contacts_hotSettings" style="margin: 20px 0 0 0">
                    <hot-column v-for="(colset, index) in contacts_columns" :settings="colset" :key="index">
                    </hot-column>
                </hot-table>
            </Col>
            <Col :md="12">
                <Button icon="md-add" @click="openDetailForm('addAddressDrawer')">Add Address</Button>
                <hot-table :settings="addresses_hotSettings" style="margin: 20px 0 0 0">
                    <hot-column v-for="(colset, index) in addresses_columns" :settings="colset" :key="index">
                    </hot-column>
                </hot-table>
            </Col>
        </Row>
        </div>

        <div v-show="screen === 'order_details'">
        <Spin fix size="small" v-if="!this.$route.params.id"></Spin>
        <Row :gutter="10">
            <Col :md="8">
                <DatePicker v-model="filterDate" type="daterange" :options="dateOptions" placeholder="Select date" :clearable="false"
                            format="dd/MM/yyyy" class="filterInput" @on-change="onChangeDate"></DatePicker>
            </Col>
            <Col :md="4">
              <Select v-model="selectedStages" multiple filterable placeholder="Status">
                <Option v-for="stage in stages" :value="stage.id" :label="stage.name" :key="stage.id">
                  <div class="ivu-select-item-div"> {{stage.name}}</div>
                </Option>
              </Select>
            </Col>
            <Col :md="4">
              <Select v-model="selectedMaterialType" placeholder="Material Type" clearable>
                <Option v-for="type in ['Sanitary', 'Tiles', 'Other']" :value="type" :label="type" :key="type">
                  <div class="ivu-select-item-div"> {{type}}</div>
                </Option>
              </Select>
            </Col>
            <Input @on-keydown="debounceInput" id="search-field" placeholder="Search by party, order no, LR etc" style="width: 300px; float: right;"/>
        </Row>
        <Row :gutter="10" style="margin-top: 10px">
          <Col span="4">
            <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: pickupCityFilter}"
                         :debounce="500" :skip="skip.pickupSkip">
              <template slot-scope="{ result: { loading, error, data } }">
                <div v-if="loading"> Loading...</div>
                <div v-else-if="error"> Error Occured. {{error}}</div>
                <div v-else>
                  <AutoComplete placeholder="Pickup City" v-model="pickupCity" :clearable="true" element-id="pickup_city"
                                @on-clear="onClearCity('pickupCity')" @on-search="onSearchCity($event, 'pickupCity')">
                    <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                      <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'pickupCity')">{{cityObj.city}}</div>
                    </Option>
                  </AutoComplete>
                </div>
              </template>
            </ApolloQuery>
          </Col>
          <Col span="4">
            <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: droppingCityFilter}"
                         :debounce="500" :skip="skip.dropSkip">
              <template slot-scope="{ result: { loading, error, data } }">
                <div v-if="loading"> Loading...</div>
                <div v-else-if="error"> Error Occured. {{error}}</div>
                <div v-else>
                  <AutoComplete placeholder="Drop City" v-model="droppingCity" :clearable="true" element-id="drop_city"
                                @on-clear="onClearCity('dropCity')" @on-search="onSearchCity($event, 'dropCity')">
                    <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                      <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'dropCity')">{{cityObj.city}}</div>
                    </Option>
                  </AutoComplete>
                </div>
              </template>
            </ApolloQuery>
          </Col>
          <Col span="3" style="float: right; text-align: end">
            <Button v-if="isAdmin" @click="exportClientDetailOrders">Export CSV</Button>
          </Col>
        </Row>

        <hot-table :settings="orders_hotSettings" ref="orders_hotTableComponent" style="margin: 20px 0 0 0">
            <hot-column v-for="(colset, index) in orders_columns" :settings="colset" :key="index">
            </hot-column>
        </hot-table>
        </div>

        <manage-order :orderId="orderId" ref="manage-order-page" :viewPath="viewPath"></manage-order>
        <update-detail ref="update-detail-form"></update-detail>
    </div>
</template>

<script>
    import { HotTable, HotColumn } from '@handsontable/vue'
    import Handsontable from 'handsontable'
    import {
      SUBSCRIBE_CLIENT_DETAIL_BY_COMPANY_ID,
      SUBSCRIBE_CONTACTS_BY_COMPANY_ID,
      SUBSCRIBE_ORDERS_BY_COMPANY_ID, SUBSCRIBE_USERS_BY_COMPANY_ID
    } from "../../graphql/subscription/companies"
    import moment from 'moment'
    import {Constants} from '../../Constants/Constant'
    import {calculateTotalWeightOfOrders} from "../ExcelTruckOrders/Settings"
    import {
      orderPriorityColors,
      dateOptions,
      generateHotSettings,
      nestedHeaders,
      roughtOfOrder
    } from "../ExcelFormattedOrders/Settings"
    import ManageOrder from "../Manage Order/ManageOrder"
    import _ from 'lodash'
    import UpdateDetail from "./UpdateDetail";
    import {GET_INTERNAL_STATUS} from "../../graphql/queries/status";
    import {getAddressString, orderDetailsRenderer} from "../ExcelFormattedOrders/RendererFunctions";
    import {SEARCH_CITY2} from "../../graphql/queries/territories";
    import {actionRenderer} from "../ExcelContractors/RendererFunctions";
    import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders";

    export default {
        name: "ClientDetail",
        components: {UpdateDetail, ManageOrder, HotTable, HotColumn },
        provide() {
            return {
                getManageOrderDrawer: () => this.manageOrderDrawer,
                setManageOrderDrawer: (data) => { this.manageOrderDrawer = data },
                getOrder: () => this.order,
                closeAssignVehicleDialog: (data) => { },
            }
        },
        apollo: {
            $subscribe: {
              orders: {
                    query: SUBSCRIBE_ORDERS_BY_COMPANY_ID,
                    skip () {return !this.$route.params.id},
                    variables() {
                        return {
                            companyId: this.$route.params.id,
                            startDate: this.startDate,
                            endDate: this.endDate,
                            stageFilter: this.selectedStages.length?this.selectedStages:null,
                            materialType: this.selectedMaterialType? {type: this.selectedMaterialType} : {},
                            searchFilter: '%' + this.globalSearch + '%',
                            lrName: { lrName: this.globalSearch },
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                        }
                    },
                    result ({ data }) {
                        this.orders = data.orders
                        this.prepareSheetDataForOrders(data.orders)
                        this.prepareArrayThenEvaluateWt(data.orders)
                    },
                },
              contacts: {
                    query: SUBSCRIBE_CONTACTS_BY_COMPANY_ID,
                    skip () {return !this.$route.params.id},
                    variables() {
                        return {
                            companyId: this.$route.params.id
                        }
                    },
                    result ({ data }) {
                      this.contacts = data.contacts;
                      this.prepareSheetDataForContacts(data.contacts)
                    },
                },
              users: {
                    query: SUBSCRIBE_USERS_BY_COMPANY_ID,
                    skip () {return !this.$route.params.id},
                    variables() {
                        return {
                            companyId: this.$route.params.id
                        }
                    },
                    result ({ data }) {
                      this.companyUsers = data.users;
                      this.prepareSheetDataForCompanyUsers(data.users)
                    },
                },
              clientDetail: {
                    query: SUBSCRIBE_CLIENT_DETAIL_BY_COMPANY_ID,
                    skip () {return !this.$route.params.id},
                    variables() {
                        return {
                            companyId: this.$route.params.id
                        }
                    },
                    result ({ data }) {
                      this.clientDetail = data.clientDetail[0]
                      this.prepareSheetDataForAddresses(data.clientDetail[0].address)
                      this.addresses = data.clientDetail[0].address;
                    },
              }
            },
            stages: { query: GET_INTERNAL_STATUS }
        },
        data: function () {
            return{
                Constants: Constants,
                screen: 'details',
                clientDetail: null,
                orders: [],
                totalWtOfOrders: 0,
                changeStatusPopup: false,
                loader1: false,
                errMessages: [],
                manageOrderDrawer: false,
                orderId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                currentOrderStatus: '',
                order: '',
                viewPath: '',
                globalSearch: '',
                filterDate: [moment().subtract(30, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
                startDate:moment().subtract(30, 'days').format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
                dateOptions: dateOptions,
                contacts_columns: [
                    //table_key_intermediate
                    {
                        title: 'Person<br> Name',
                        data: 'name',
                    },
                    {
                        title: 'Mobile',
                        data: 'mobile',
                    },
                    {
                        title: 'Type',
                        data: 'type',
                    },
                    {
                      title:'Action',
                      data: 'action',
                      renderer: (...args) => actionRenderer(...args, this, 'contacts', 'onEditContact', 'onDeleteContact')
                    }

                ],
                contacts_hotSettings: generateHotSettings([145, 100, 100, 60], nestedHeaders.contactsTable),
                companyUsers_columns: [
                    //table_key_intermediate
                    {
                        title: 'Name',
                        data: 'name',
                    },
                    {
                        title: 'Mobile',
                        data: 'mobile',
                    },
                    {
                        title: 'Email',
                        data: 'email',
                    },
                    {
                      title:'Action',
                      data: 'action',
                      renderer: (...args) => actionRenderer(...args, this, 'companyUsers', 'onEditCompanyUser', 'onDeleteCompanyUser')
                    }
                    // {
                    //     title: 'Role',
                    //     data: 'role',
                    // },

                ],
                companyUsers_hotSettings: generateHotSettings([145, 100, 180, 60], nestedHeaders.companyUsersTable),
                addresses_columns: [
                    //table_key_intermediate
                    {
                        title: 'SR No.',
                        data: 'serialNum',
                    },
                    {
                        title: 'address',
                        data: 'address',
                    },
                    {
                      title:'Action',
                      data: 'action',
                      renderer: (...args) => actionRenderer(...args, this, 'addresses', 'onEditAddress', 'onDeleteAddress')
                    }
                ],
                addresses_hotSettings: generateHotSettings([50, 400, 60], nestedHeaders.addressesTable),
                orders_columns: [
                    //table_key_intermediate
                    {
                        title: 'Created On',
                        data: 'createdAt',
                        type: 'date',
                        dateFormat: 'DD MMM \'YY hh:mm A'
                    },
                    {
                        title: 'Updated On',
                        data: 'updatedAt',
                        type: 'date',
                        dateFormat: 'DD MMM \'YY hh:mm A'
                    },
                    {
                        title: 'Pickup<br> Date',
                        data: 'orders_pickupDate',
                        type: 'date', dateFormat: 'DD/MM/YYYY'
                    },
                    {
                        title: 'ERP Order No',
                        data: 'orderNumber',
                        renderer: this.orderNumberRenderer
                    },
                    {
                      title: 'Route',
                      data: 'rought'
                    },
                    {
                        title:'Status',
                        data: 'internalStatus'
                    },
                    {
                        title:'Comment',
                        data: 'comment'
                    },
                    {
                        title:'LR No.',
                        data: 'orderDetails_lrName_lrObject'
                    },
                    {
                        title:'Client Name',
                        data: 'clientName'
                    },
                    {
                        title:'Pickup Point',
                        data: 'pickupPartyName'
                    },
                    {
                        title:'Drop Point',
                        data: 'dropPartyName'
                    },
                    {
                        title:'Company',
                        data: 'companyName'
                    },
                    {
                        title:'Total<br> Weight',
                        data: 'kg',
                        type: 'numeric'
                    },
                    {
                        title:'Order<br> Details',
                        data: 'boxes',
                        renderer: (...args) => orderDetailsRenderer(...args, this, 'orders')
                    },
                    {
                        title:'Eway Bill No',
                        data: 'orderDetails_ewayBillNo',
                    }
                ],
                orders_hotSettings: generateHotSettings([120, 120, 110, 145, 145, 145, 180, 100, 145, 145, 145, 145, 100, 100, 130]),
                confirmDialog: false,
                confirmObj: {},
                updateRecord_loader: false,
                contacts: [],
                companyUsers: [],
                stages: [],
                selectedStages: [],
                selectedMaterialType: null,
                query_SEARCH_CITY: SEARCH_CITY2,
                pickupCity: '',
                droppingCity: '',
                skip: {pickupSkip: true, dropSkip: true}, //To Avoid calls at initial
                pickupCityFilter: '%%',
                droppingCityFilter: '%%',
                selectedPickupCity: {"address":[]},
                selectedDroppingCity: {"address":[]},
                getAddressString: getAddressString,
                addresses: []
            }
        },
        computed: {
          isAdmin: function(){
            return this.$store.state.userObj.role[0].id === Constants.adminRoleId
          }
        },
        methods:{
            debounceInput: _.debounce(function (e) {
                this.globalSearch = e.target.value
            }, 500),
            onChangeDate(evt){
                this.startDate = moment(evt[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
                this.endDate = moment(evt[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
            },
            prepareSheetDataForContacts(data){
                let mainArr = []
                data.forEach(curnt => {
                    curnt.obj = {
                        name: curnt.name,
                        mobile: curnt.mobile,
                        type: curnt.role === 1?'Marketing':'Dispatch'
                    }
                    mainArr.push(curnt.obj)
                })
                this.contacts_hotSettings.data = mainArr
            },
            prepareSheetDataForCompanyUsers(data){
                let mainArr = []
                data.forEach(curnt => {
                    curnt.obj = {
                        name: curnt.name,
                        mobile: curnt.mobile,
                        email: curnt.email,
                        type: curnt.role === 1?'Marketing':'Dispatch'
                    }
                    mainArr.push(curnt.obj)
                })
                this.companyUsers_hotSettings.data = mainArr
            },
            prepareSheetDataForAddresses(data){
                let mainArr = []
                data.forEach((curnt, index) => {
                    curnt.obj = {
                        serialNum: index+1,
                        address: getAddressString(curnt)
                    }
                    mainArr.push(curnt.obj)
                })
                this.addresses_hotSettings.data = mainArr
            },
            orderNumberRenderer(instance, td, row, col, prop, value, cellProperties) {
                Handsontable.renderers.TextRenderer.apply(this, arguments);
                let priority = instance.getDataAtRowProp(row, 'priority')                               //prop name 'priority'

                td.innerHTML = value.substring(0, 9) + '<p>' + value.substring(9, value.length) + '</p>'

                if(orderPriorityColors[priority]){
                    td.style.color = orderPriorityColors[priority]
                }
                td.classList.add('order-num-txt')
              let pRow = instance.toPhysicalRow(row)                             //When accessing original array
                let order = this.orders[pRow]
                let self = this
                td.onclick = function() {
                    self.editOrder(order)
                }
            },
            editOrder(order){
                this.orderId = order.id;
                this.viewPath = order.internalStatus.viewPath;      //Load form based on internalStatus.viewPath
                this.order = order;
                this.currentOrderStatus = order.internalStatus.id;
                this.manageOrderDrawer = true;
            },
            prepareSheetDataForOrders(data){
                let mainArr = []
                data.forEach(curnt => {
                    curnt.obj = {
                        createdAt: moment(curnt.createdAt).format('DD MMM \'YY hh:mm A'),
                        updatedAt: moment(curnt.updated_at).format('DD MMM \'YY hh:mm A'),
                        orders_pickupDate: moment(curnt.pickupDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                        orderNumber: curnt.orderNumber,
                        internalStatus: curnt.internalStatus.name,
                        rought: roughtOfOrder(curnt),
                        comment: curnt.notes.length?curnt.notes[0].note:'',
                        clientName: curnt.clientobject.name,
                        pickupPartyName: curnt.orderDetails&&curnt.orderDetails.pickupPoint&&curnt.orderDetails.pickupPoint.pickupPartyId?
                            curnt.orderDetails.pickupPoint.pickupPartyName:curnt.pickuppartyobject.name,
                        dropPartyName: curnt.orderDetails&&curnt.orderDetails.dropPoint&&curnt.orderDetails.dropPoint.dropPartyId?
                            curnt.orderDetails.dropPoint.dropPartyName:curnt.droppingpartyobject.name,
                        companyName: curnt.pickuppartyobject.name,
                        kg: curnt.materials.kg,
                        boxes: curnt.materials.boxes,
                        orders_note: curnt.note?curnt.note:'-',
                        orderDetails_lrName_lrObject: curnt.orderDetails&&curnt.orderDetails.lrObject?curnt.orderDetails.lrObject.lrName:'',
                        orderDetails_ewayBillNo: curnt.orderDetails&&curnt.orderDetails.ewayBillNo?curnt.orderDetails.ewayBillNo:'-',
                        priority: curnt.priority,
                        internalStatusId: curnt.internalstatus,
                        unlink: 'unlink'
                    }
                    mainArr.push(curnt.obj)
                })
                this.orders_hotSettings.data = mainArr
            },
            prepareArrayThenEvaluateWt(arr){
                arr = arr.map((obj) => {return {order: obj}})
                this.totalWtOfOrders = calculateTotalWeightOfOrders(arr)
            },
            openDetailForm(drawer){
              this.$refs['update-detail-form'][drawer] = true;
              if(drawer === 'addAddressDrawer'){ this.$refs['update-detail-form']['addressArr'] = this.clientDetail.address; }
            },
            onEditContact(contact){
              this.$refs['update-detail-form'].onEditContact(contact);
            },
            onDeleteContact(contactId){
              this.$refs['update-detail-form'].onDeleteContact(contactId);
            },
            onEditCompanyUser(user){
              this.$refs['update-detail-form'].onEditCompanyUser(user);
            },
            onDeleteCompanyUser(userId){
              this.$refs['update-detail-form'].onDeleteCompanyUser(userId);
            },
            onEditAddress(data, index){
              this.$refs['update-detail-form'].onEditAddress(data, index);
              this.$refs['update-detail-form']['addressArr'] = this.addresses;
            },
            onDeleteAddress(addressId, index){
              this.$refs['update-detail-form'].onDeleteAddress(addressId, index);
              this.$refs['update-detail-form']['addressArr'] = this.addresses;
            },
            onSearchCity(event, str){
              if(str === 'pickupCity'){
                this.pickupCityFilter = '%' + this.pickupCity + '%';
                this.skip.pickupSkip = false;
              }else if(str === 'dropCity'){
                this.droppingCityFilter = '%' + this.droppingCity + '%';
                this.skip.dropSkip = false;
              }
            },
            onSelectCity(city, str){
              if(str === 'pickupCity'){
                this.selectedPickupCity = {"address":[{"city": city}]};
              }else if(str === 'dropCity'){
                this.selectedDroppingCity = {"address":[{"city": city}]};
              }
            },
            onClearCity(str){
              if(str === 'pickupCity'){
                this.selectedPickupCity = {"address":[]};
              }else if(str === 'dropCity'){
                this.selectedDroppingCity = {"address":[]};
              }
            },
            onChangeStatus(row){
              this.$Modal.confirm({
                title: 'Confirmation',
                content: '<p>Are You sure want to change status of Client ?</p>',
                loading: true,
                onOk: () => {
                  let obj = {isApproved: row.isApproved, isRejected: !row.isApproved}
                  this.updateRecord(row.id, obj, 'company', this.$Modal)

                  obj = {isApproved: row.isApproved}
                  this.updateRecord(row.AddressbookCompany.id, obj, 'addressbookedcompany')
                },
                onCancel: () => {
                  row.isApproved = !row.isApproved
                }
              });
            },
            onChangeSendSms(row){
              this.$Modal.confirm({
                title: 'Confirmation',
                content: `<p>Are You sure want to ${row.preference.sendSms?'ON':'OFF'} Send SMS of Client ?</p>`,
                loading: true,
                onOk: () => {
                  let obj = {preference: row.preference}
                  this.updateRecord(row.id, obj, 'company', this.$Modal)
                },
                onCancel: () => {
                  row.preference.sendSms = !row.preference.sendSms
                }
              });
            },
            async updateRecord(id, obj, table, callback){
              let response = await this.$apollo.mutate({
                mutation: generate_UPDATE_ORDER_DATA(table),
                variables: { id: id, obj: obj}
              })
              if(response.data){
                this.$Message.success('Client updated successfully!')
                callback?.remove();
              }
            },
            exportClientDetailOrders(){
              let exportPlugin = this.$refs['orders_hotTableComponent'].hotInstance.getPlugin('exportFile');
              let str = exportPlugin.exportAsString('csv', {columnHeaders: true});

              let json = {
                'Client Name': this.clientDetail.name,
                'Mobile No.': this.clientDetail.mobile,
                'Email': this.clientDetail.email,
                'Address': getAddressString(this.clientDetail.address[0]),
                'GST': this.clientDetail.gstin?this.clientDetail.gstin:'-',
                'PAN': '-',
                'City': this.clientDetail.address[0].city,
                'Status': this.clientDetail.isApproved?'Active':'InActive',
                'Total Orders': this.orders.length,
                'Total Billing Amt': '',
                'Total Paid Amt': '',
                'Due Amt': ''
              }
              str = str.replace(/<\/?[^>]+(>|$)/g,"") + '\n\n';        //Remove html tags if any
              Object.keys(json).forEach((key) => {
                str = str + key + ',' + json[key] + '\n';
              });

              let blob = new Blob([str], {type: 'text/plain'});
              const a = window.document.createElement('a');
              a.href = window.URL.createObjectURL(blob);
              a.download = 'clientDetail_Orders_' + moment().format('DD_MMM_YYYY_HH_mm') +'.csv';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            }
        },
        async mounted(){}
    }
</script>

<style scoped>
    /deep/  .ivu-spin-fix {
        top: 43px;
        left: 16px;
        z-index: 8;
        width: 86vw;
        height: 40vh;
    }
    /deep/ .handsontable > .ht_master{
        font-size: 14px;
    }
    /deep/ .handsontable > .ht_master > .wtHolder{
        /*width: 100% !important;*/
        width: unset !important;
        height: unset !important;
    }
    /deep/ .handsontable span.colHeader {
        font-size: 13px;
    }
    /deep/.handsontable td{
        vertical-align: middle !important;
        padding: 0 1px 0 1px !important;
        white-space: unset !important;
        font-size: 13px;
    }

    /deep/.handsontable th{
        background-color: #d9d9d9;
        color: #222;
        text-align: center;
        font-weight: 600;
        vertical-align: middle !important;
        white-space: nowrap !important;
        padding: 0 0px 0 0px !important;
    }
    .filterInput{
        width: 80%;
    }
    /deep/ .ivu-date-picker-cells  {
        font-size: 12px !important;
    }
    /deep/ .ivu-picker-panel-sidebar  {
        width:125px !important;
        margin-left:-116px !important;
    }
    .refresh-icon{
        float: right;
        margin: 9px 16px;
        font-size: 14px;
        cursor: pointer;
    }
</style>
<style>
     .add-user-btn{
     /*position: absolute;*/
     /*top: 0;*/
     }
    .order-num-txt:hover {
        text-decoration: underline;
    }
     .green-text{
       color: green !important;
     }
     .red-text{
       color: red !important;
     }
     .action-edit{
       font-size: 12px;
       color:grey;
       margin-right:15px;
       cursor: pointer;
     }
     .action-delete{
       font-size: 12px;
       color:red;
       cursor: pointer;
     }
     .action-delete:hover{
       color: #FF8C00;
     }
     .action-edit:hover{
       color: #c0c0c0;
     }
</style>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>
